import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICompanyconfigModel } from '../../models/config-model';

@Injectable({ providedIn: 'root' })
export class companyConfigService {
  private companyconfig: ICompanyconfigModel = {
    CompanyConfig: {},
    DBConfig: {},
    GuestToken: {}
  };
  constructor(private http: HttpClient) { }
  setCompanyConfig(config: any) {
    this.companyconfig.CompanyConfig = config;
  }
  setDbConfig(config: any) {
    this.companyconfig.DBConfig = config;
  }
  setGuestToken(token: any) {
    this.companyconfig.GuestToken = token;
  }
  getGuestToken() {
    return this.companyconfig.GuestToken;
  }
  getConfig() {
    return this.companyconfig;
  }
}
